import { useLocation } from 'react-router-dom';

export const useQueryParams = () => {
  return new window.URLSearchParams(useLocation().search);
};
